import { css } from 'styled-components';
import { fluidUnit } from './fluid';
/**
 * Returns the aspect ratio of the given width and height as a percentage.
 */
export function aspectRatio(width, height) {
    return (height / width) * 100;
}
export function imageWrapperPreserveRatio(width, height, 
/**
 * Additonal values to use if the ratio increases over time
 */
maxWidth, maxHeight) {
    if (!width && !height) {
        return null;
    }
    let padding;
    if (maxWidth && maxHeight) {
        padding = `${fluidUnit(aspectRatio(width, height), aspectRatio(maxWidth, maxHeight), '%')}`;
    }
    else {
        padding = `${aspectRatio(width, height)}%`;
    }
    return css `
    position: relative;
    height: 0;
    width: 100%;
    overflow: hidden;
    overflow: clip;
    padding-bottom: ${padding};
  `;
}
/**
 * Re-usable styles for an image placed within
 * a container maintaining aspect ratio
 */
export const imageCoverContainer = (relative) => css `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  ${!relative && 'position: absolute; top: 0;left: 0;'}
`;
